import axios from '@/utils/api.request'
// import axios from 'axios'
let previousUrl = '/api'
export const getAlarmCaseInfo = (id) => {
    return axios.request({
        url: `${previousUrl}/AlarmInfo/${id}`,
        method: 'get'
    })
}

export const getNiceCaseInfo = (id) => {
    return axios.request({
        url: `${previousUrl}/Example/${id}`,
        method: 'get'
    })
}

export const delNiceCase = (id) => {
    return axios.request({
        url: `${previousUrl}/Example/delete/${id}`,
        method: 'delete'
    })
}

export const getAlarmCaseDraftCase = (id) => {
    return axios.request({
        url: `${previousUrl}/AlarmInfo/draftCase/${id}`,
        method: 'get'
    })
}

export const getAlarmCaseAssign = (data) => {
    return axios.request({
        url: `${previousUrl}/AlarmInfo/assign/${data.id}`,
        method: 'post',
        data: data
    })
}

export const agreeCase = (data) => {
    return axios.request({
        url: `${previousUrl}/AlarmInfo/done/${data}`,
        method: 'get'
    })
}

export const suggestNew = (data) => {
    return axios.request({
        url: `${previousUrl}/AlarmInfo/suggentNew/${data}`,
        method: 'get'
    })
}
